import {
  GroupsManagerEnrollmentsOrderByFieldsEnum,
  GroupsManagerEnrollmentsSearchableFieldsEnum,
  OrderByDirection,
} from "@models/ISchema";
import { create } from "zustand";
import { EnrollmentsTableColumn } from "../models";

export interface EnrollmentsTableFiltersState {
  orderBy: {
    header: EnrollmentsTableColumn;
    field: GroupsManagerEnrollmentsOrderByFieldsEnum;
    direction: OrderByDirection;
  };
  searchBy: {
    text: string;
    fields: GroupsManagerEnrollmentsSearchableFieldsEnum[];
  };
}

const initialState = {
  orderBy: {
    header: null,
    field: null,
    direction: null,
  },
  searchBy: {
    text: "",
    fields: [],
  },
};

export const useEnrollmentsTableFilters = create<EnrollmentsTableFiltersState>(() =>
  structuredClone(initialState),
);

export const setOrderBy = (orderBy: EnrollmentsTableFiltersState["orderBy"]) =>
  useEnrollmentsTableFilters.setState({ orderBy });

export const setSearchBy = (searchBy: EnrollmentsTableFiltersState["searchBy"]) =>
  useEnrollmentsTableFilters.setState({ searchBy });

export const reset = () => useEnrollmentsTableFilters.setState(structuredClone(initialState));
